import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
import { MCSContext } from "../../MCS.context";
import { getAllVouchers } from "../../api";

export default function SelectFromExistedEntities({
  selectedCurrentAction,
  onSelectEntity,
  actionRadioBtnsData,
  onClickRadioBtn,
  currentAction,
}) {
  const { mrqData, setMrqData } = React.useContext(MCSContext);
  const [existedEntities, setExistedEntities] = React.useState([]);

  React.useEffect(() => {
    if (currentAction === "po") {
      setExistedEntities(mrqData?.pos);
    } else {
      const func = async () => {
        const data = await getAllVouchers(currentAction);
        setExistedEntities(data);
        setMrqData({ ...mrqData, [currentAction + "s"]: data });
      };

      func();
    }
  }, []);

  return (
    <>
      <FormControl
        sx={{
          width: "100%",
          maxHeight: "250px",
          overflow: "auto",
        }}
      >
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={selectedCurrentAction}
          onChange={onSelectEntity}
          sx={{ pl: 2 }}
        >
          {existedEntities?.[0] ? (
            <>
              {existedEntities.map((po) => {
                return (
                  <FormControlLabel
                    checked={actionRadioBtnsData.number === po.number}
                    value={po.number}
                    control={<Radio />}
                    label={po.number}
                    onClick={onClickRadioBtn}
                  />
                );
              })}
            </>
          ) : (
            <p
              style={{
                color: "#bbb",
                fontSize: "14px",
                textAlign: "center",
                padding: 3,
              }}
            >
              {"No " + currentAction.toUpperCase() + "s Found yet."}
            </p>
          )}
        </RadioGroup>
      </FormControl>
    </>
  );
}
